export const API_URL = process.env.REACT_APP_API_URL || '/api'
export const DEFAULT_CURRENCY = 'INR'
export const DEFAULT_LOCALIZATION = 'en-IN'
export const DEFAULT_COUNTRY = 'India'
export { PageURLs } from './routes'
